import type { PropsWithChildren, ReactNode, SVGProps } from "react";

import { AlertTriangleIcon, CircleCheckOverIcon, ExclamationCircleIcon } from "../../components";
import { cn } from "../../utils";
import { useAlertRootContext } from "./context";
import { alertLayoutStyle } from "./styles";

export type AlertIconLayoutProps = PropsWithChildren<{
  Icon?: (props: SVGProps<SVGSVGElement>) => ReactNode;
  className?: string;
  title: ReactNode;
}>;

const IconLayout = ({ Icon, children, className, title }: AlertIconLayoutProps) => {
  const { type, orientation } = useAlertRootContext();

  const getIcon = () => {
    switch (type) {
      case "primary":
      case "secondary":
      case "error":
        return ExclamationCircleIcon;
      case "warning":
        return AlertTriangleIcon;
      case "success":
        return CircleCheckOverIcon;
      default:
        return null;
    }
  };

  const IconToUse = Icon || getIcon();

  return (
    <div className={cn(alertLayoutStyle({ orientation }), "gap-3 items-start", className)}>
      {IconToUse && <IconToUse className="w-5 h-5 shrink-0" />}
      <div className="flex flex-col gap-1">
        <h3 className="font-semibold mr-4">{title}</h3>
        {children}
      </div>
    </div>
  );
};

export default IconLayout;
